define('views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'services/i18n',
    // views
    'views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-header',
    'views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-week',
    // parent view
    'views/modules/calendar/animated-session/exercise/weight/weight-content',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // views
    VWeightBriefHeader,
    VWeightBriefWeek,
    // parent view
    VWeightExerciseContent,
    // templates
    TWeekBriefContent
) {

    var VWeightBriefContent = VWeightExerciseContent.extend({
        template: TWeekBriefContent,
        headerView: VWeightBriefHeader,
        weekView: VWeightBriefWeek,

        initialize: function(opt) {
            VWeightBriefContent.__super__.initialize.call(this, opt);
            var week = this.collection.at(opt.item.getWeek());

            _.extend(this.options, {
                setsTranslation: i18n.t('calendar:SetsWithCount', { count: week.get('numSets') })
            });

            _.extend(this, {
                bindingSources: {
                    week: week
                }
            });
        },

        render: function() {
            this.enableMultiReps();
            VWeightBriefContent.__super__.render.apply(this, arguments);
        },

        enableMultiReps: function() {
            var model = this.model,
                week = model.getWeek(this.options.item.getWeek());
            //if (week.get('numSets') > 1 && !model.hasMultiRep()) {
            if (!model.hasMultiRep()) {
                model.toggleMultiReps(true, { silent: true });
                this.copyFirstSetData();
            }
        },

        // If multireps is not enabled yet, we copy the first set data to the other sets to populate exercise details (set, load , rest)
        copyFirstSetData: function() {
            var week = this.model.getWeek(this.options.item.getWeek());
            week.copyFirstSetData();
        },

        toggleLoad: _.noop

    });

    return VWeightBriefContent;

});

